'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/._rc-trigger@1.9.1@rc-trigger/lib/index.js
 ** module id = 42
 ** module chunks = 0 1
 **/